import '@rce-web/ui-upgrade-dialog/dist/styles.css';

import { Button } from '@app/features/analytics/components';
import { getBaseUrl } from '@hopin-team/dashboard-constants';
import { getSlugFromPath } from '@hopin-team/dashboard-shared';
import { useReadDashboardSharedState } from '@hopin-team/dashboard-shared-react';
import { useTranslation } from '@hopin-team/provider-translation';
import { UpgradeDialog } from '@rce-web/ui-upgrade-dialog';
import React, { useMemo, useState } from 'react';

import BannerImg from './banner.png';

export const UpgradeBanner = ({
  organizationId,
  freeTrialEnabled,
}: {
  organizationId: string;
  freeTrialEnabled: boolean | undefined;
}) => {
  const flags = useReadDashboardSharedState('feature_flags');
  const eventsProPlansFlagEnabled = flags['events-pro-plans'];
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState(false);
  const { t } = useTranslation();
  const slug = useMemo(() => getSlugFromPath(window.location.pathname), []);
  const choosePlanButtonHref = `/org/${slug}/manage/billing`;

  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="flex w-full h-[340px] border border-neutral-b4 rounded-lg overflow-hidden">
        <div className="flex-1 flex flex-col p-10 justify-center">
          <div className="flex flex-col mb-8">
            <span className="font-inter text-2xl font-normal leading-8 text-neutral-b1 break-words mb-2">
              {t('analytics.upgrade-banner-title')}
            </span>
            <span className="font-inter text-subtitle text-gray-750 break-words">
              {t('analytics.upgrade-banner-description')}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <Button
              className="!bg-blue-400 !w-[160px] !rounded-10"
              size="medium"
              kind="primary"
              data-testid="upgrade-button"
              onClick={evt => {
                if (freeTrialEnabled && !eventsProPlansFlagEnabled) {
                  setUpgradeDialogOpen(true);
                  evt.preventDefault();

                  return;
                }
                window.location.assign(choosePlanButtonHref);
              }}
            >
              {t('analytics.upgrade-banner-button')}
            </Button>
          </div>
        </div>

        <div className="w-[400px] relative flex items-center justify-center">
          <div className="absolute top-[-425px] left-6 w-[1200px] h-[1200px] bg-orange-banner rounded-full overflow-hidden">
            <div className="absolute top-[450px] left-0">
              <img src={BannerImg} alt={''} />
            </div>
          </div>
        </div>
        {freeTrialEnabled && (
          <UpgradeDialog
            isOpen={upgradeDialogOpen}
            onClose={() => setUpgradeDialogOpen(false)}
            options={{
              host: getBaseUrl(),
              organisationId: organizationId,
              source: 'organizer_dashboard_apps',
            }}
            translations={t('upgrade-dialog', { returnObjects: true })}
          />
        )}
      </div>
    </div>
  );
};
